import React, { useContext, useEffect, useState } from 'react'
import './style/how.css'
import how1 from '../images/ze5oz-ida3r.jpg'
import how2 from '../images/how2.jpg'
import how3 from '../images/how3.jpg'
import how4 from '../images/how4.jpg'
import how4_1 from '../images/how4-1.jpg'
import how5 from '../images/how5.jpg'
import how6 from '../images/how6.jpg'
import { TextField } from '@mui/material'
import { useFilters } from '../components/context/FilterContext'
import LoadingIndicator from '../components/LoadingIndicator';
import axios from 'axios'
import { host } from '../components/host'
import Card from '../components/card/Card'
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Carousel, { Modal, ModalGateway } from 'react-images'
import { UserContext } from '../components/context/UserContext'
import { useNavigate } from 'react-router-dom'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 208,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName === name
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const getQueryParam = (param) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(param);
};

const HowToCreate = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const { filters, updateFilters } = useFilters();
  const [tempFilters, setTempFilters] = useState({
    type: filters.type,
    organizationalization: filters.organizationalization,
    city: filters.city,
    id: filters.id,
    categories: filters.categories,
    attributes: filters.attributes,
  });
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [type, setType] = useState('')
  const [organizationalization, setOrganizationalization] = useState('')
  const [categoryId, setCategoryId] = useState('')
  const [attributeId, setAttributeId] = useState('')
  const [city, setCity] = useState('')
  const [number, setNumber] = useState('')
  const [sortOrder, setSortOrder] = useState('newest'); // Добавляем состояние для сортировки
  const theme = useTheme();
  const [id, setId] = useState(null);

  const organ = [
    'ТОО Довеку',
    'ТОО Азия Стиль',
    'ТОО 12 Месяцев Астана',
    'ТОО 12 Месяцев Алмата',
    'ТОО 12 Месяцев Павлодар',
    'ТОО 12 Месяцев Костанай',
    'ТОО 12 Месяцев Восток',
    'ТОО Азия Декор',
    'ТОО Азия Креатив',
  ]

  const types = [
    'Брак',
    'Недопоставка',
    'Пересорт',
    'Обычный'
  ]

  const citys = [
    'Актобе',
    'Алмата',
    'Астана',
    'Караганда',
    'Костанай',
    'Павлодар',
    'Семей',
    'Усть-Каменогорск',
    'Шымкент',
    'Экибастуз'
  ]
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/login')
    }
    const idFromUrl = getQueryParam('id');
    if (idFromUrl) {
      setId(idFromUrl);
    }
    axios.get(`${host}/api/v1/category`)
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
    axios.get(`${host}/api/v1/attribute`)
      .then((response) => {
        setAttributes(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);
  const handleSaveFilters = () => {
    updateFilters({ ...tempFilters });
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    if (name === 'type') {
      setTempFilters({ ...tempFilters, type: value });
    } else if (name === 'organizationalization') {
      setTempFilters({ ...tempFilters, organizationalization: value });
    } else if (name === 'city') {
      setTempFilters({ ...tempFilters, city: value });
    } else if (name === 'number') {
      setTempFilters({ ...tempFilters, id: value });
    } else if (name === 'category') {
      setTempFilters({
        ...tempFilters, categories: value
      });
    } else if (name === 'attribute') {
      setTempFilters({
        ...tempFilters, attributes: value
      });
    }
  };
  return (
    <div className='how'>
      <div className="sitebar">
        <div className="sitebar__title">
          <p>ПОИСК ПО ФИЛЬТРУ</p>
        </div>
        <div className="sitebar__filter">
          {/* <div className="sitebar__filter-inp">
            <label>Тип акта</label>
            <FormControl sx={{ width: '100%' }}>
              <Select
                sx={{
                  backgroundColor: '#FFF',
                  height: '40px',
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                name='type'
                value={tempFilters.type}
                onChange={handleFilterChange}
                MenuProps={MenuProps}
              >
                {types.map((item) => (
                  <MenuItem
                    sx={{
                      width: '100%'
                    }}
                    key={item}
                    value={item}
                    style={getStyles(item, item, theme)}
                  >
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="sitebar__filter-inp">
            <label>Организация</label>
            <FormControl sx={{ width: '100%' }}>
              <Select
                sx={{
                  backgroundColor: '#FFF',
                  height: '40px',
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                name='organizationalization'
                value={tempFilters.organizationalization}
                onChange={handleFilterChange}
                MenuProps={MenuProps}
              >
                {organ?.map((item) => (
                  <MenuItem
                    sx={{
                      width: '100%'
                    }}
                    key={item}
                    value={item}
                    style={getStyles(item, item, theme)}
                  >
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div> 
          <div className="sitebar__filter-inp">
            <label>Город</label>
            <FormControl sx={{ width: '100%' }}>
              <Select
                sx={{
                  backgroundColor: '#FFF',
                  height: '40px',
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                name="city"
                value={tempFilters.city}
                onChange={handleFilterChange}
                MenuProps={MenuProps}
              >                  
              {citys?.map((item) => (
                <MenuItem
                  sx={{
                    width: '100%'
                  }}
                  key={item}
                  value={item}
                  style={getStyles(item, item, theme)}
                >
                  {item}
                </MenuItem>
              ))}
              </Select>
            </FormControl>
          </div> */}
           <div className="sitebar__filter-inp">
            <label>Транспортная единица</label>
            <FormControl sx={{ width: '100%' }}>
              <Select
                sx={{
                  backgroundColor: '#FFF',
                  height: '40px',
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                name="category"
                value={tempFilters.categories}
                onChange={handleFilterChange}
                MenuProps={MenuProps}
              >
                {categories.map((item) => (
                  <MenuItem
                    sx={{
                      width: '100%'
                    }}
                    key={item}
                    value={item.id}
                    style={getStyles(item, item.name, theme)}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
         <div className="sitebar__filter-inp">
            <label>Тип товара:</label>
            <FormControl sx={{ width: '100%' }}>
              <Select
                sx={{
                  backgroundColor: '#FFF',
                  height: '40px',
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                value={tempFilters.attributes}
                name="attribute"
                onChange={handleFilterChange}
                MenuProps={MenuProps}
              >
                {attributes.map((item) => (
                  <MenuItem
                    sx={{
                      width: '100%'
                    }}
                    key={item}
                    value={item.id}
                    style={getStyles(item, item.name, theme)}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="sitebar__filter-inp">
            <label>Номер Акта</label>
            <TextField
              type='number'
              onChange={handleFilterChange}
              name='number'
              sx={{
                width: "100%",
                height: '40px',
                background: '#FFF',
                '& .MuiInputBase-root': {
                  height: '100%',
                },
              }} id="outlined-basic" variant="outlined" />
          </div>

          <button onClick={handleSaveFilters} style={{
            width: '100%'
          }} className='btn'>НАЙТИ</button>
        </div>
      </div>
      <div className="how__blocks">
        <div className="how__block">
          <div className="how__title">
            <span>1. Для создания акта Вам необходимо нажать на кнопку <span className='underline'>"Создать документ"</span></span>
          </div>
          <img src={how1} alt="" />
        </div>
        <div className="how__block">
          <div className="how__title">
            <span>2. Откроется страница создания акта, где необходимо заполнить данные. <br />
            Знаком * помечены обязательные поля для заполнения. </span>
            <p style={{
              marginTop:'10px'
            }}><span>Тип акта *</span> - При выборе типов <span>Брак, Пересорт</span> или <span>Недостача</span>, акт будет сохранен в течении 2 лет. </p>
            <p><span>Организация *</span> - ТОО которая принимает товар</p>
            <p><span>Город *</span> - город в котором принимается товар</p>
            <p><span>Транспортная единица *</span> - тр. единица на которой был доставлен товар</p>
            <p><span>Тип товара *</span>- идентичен папкам из номенклатуры в 1С</p>
            <p><span>Номер тр. единицы *</span> - идентификатор тр. единицы. В случае авто - Гос. номера транспортного средства</p>
            <p><span>Поставщик *</span>  - Поставщик от которого поставлен товар</p>
            <p><span>Сопр. Документы *</span> - Инвосы, акты, накладные и т.п.</p>
            <p><span>Комментарий</span> - любая полезная информация. (можно будет найти через поиск)</p>
            <p><span>Ответственные *</span> - ФИО ответсвенных лиц.</p>
          </div>
          <img src={how2} alt="" />
        </div>
        <div className="how__block">
          <div className="how__title">
            <span>3. Следующий шаг - это Загрузка акта, Фото и Видео </span>
            <p><span>Загрузить акт</span> - вызывает окно загрузки акта. Принимается файлы pdf или любой формат изображения</p>
            <p><span>Загрузить Фото</span> - любое количество фотографий.</p>
            <p><span>Загрузить Видео</span> - любое количество видео файлов.</p>
            <p style={{
              marginTop:'10px',
              color:'red'
            }}><span style={{
              color:'red'
            }}>Важно!</span> При добавлении видео файлов большого размера, сам видео файл в акте может появиться в течении 5-10 минут. Будет происходить компрессия видео для оптимизации хранилища. </p>
          </div>
          <img src={how3} alt="" />
        </div>
        <div className="how__block">                                                                                  
          <div className="how__title">
            <p>4. Убедитесь что все данные заполнены верно, и нажмите кнопку  <span>Создать Акт</span></p>
            <p>После следует дождаться прогресса загрузки и индикатора что Акт успешно создан.</p>
          </div>
          <div className="how__img">
            <img src={how4} alt="" />
            <img src={how4_1} alt="" />
          </div>
        </div>
        <div className="how__block">
          <div className="how__title">
            <span>5. Ваш акт успешно создан! Теперь ему присвоен порядковый номер для легкого поиска.</span>
            <p>Все фото и видео материалы можно просматривать на сайте, или при необходимости скачать себе на устройство.</p>
            <p>Акт который был прикреплён при создании,  можно скачать нажав на кнопку <span>Скачать акт</span></p>
          </div>
          <img src={how5} alt="" />
        </div>
        <div className="how__block">
          <div className="how__title">
            <span>6. Чтобы быстро найти акт, можно воспользоваться фильтром, или поиском по ключевым словам.</span>
          </div>
          <img src={how6} alt="" />
        </div>
      </div>
    </div>
  )
}

export default HowToCreate
